import { h } from 'preact';
import { useEffect } from 'preact/hooks';
import fitvids from 'fitvids';

window.fitvids = fitvids;

export default function TableauVisualization(props) {
  useEffect(() => {
    const callFitvids = () => {
      fitvids();
    };
    const int = setInterval(callFitvids, 1500);
    return () => {
      clearInterval(int);
    };
  }, []);
  useEffect(() => {
    var container = document.getElementById(props.id);
    var iframe = container.getElementsByTagName('iframe')[0];
    if (container.offsetWidth > 800) {
      iframe.style.width = props.width + 'px';
      iframe.style.height = props.height + 'px';
    } else if (container.offsetWidth > 500) {
      iframe.style.width = props.width + 'px';
      iframe.style.height = props.height + 'px';
    } else {
      iframe.style.width = '100%';
      iframe.style.height = props.minHeight + 'px';
    }
  }, [props.isMobile]);

  return (
    <div class="tableauPlaceholder" id={props.id}>
      <object class="tableauViz" style={{ display: 'none' }}>
        <param name="host_url" value="https://public.tableau.com/" />
        <param name="embed_code_version" value="3" />
        <param name="site_root" value="" />
        <param name="name" value={props.path} />
        <param name="tabs" value="no" />
        <param name="toolbar" value="no" />
        <param
          name="static_image"
          value={`https://public.tableau.com/static/images/${props.placeholderImagePath}`}
        />
        {props.loadOrder && <param name="load-order" value={props.loadOrder} />}
        <param name="showShareOptions" value="false" />
        <param name="animate_transition" value="no" />
        <param name="display_static_image" value="no" />
        <param name="display_spinner" value="no" />
        <param name="display_overlay" value="no" />
        <param name="display_count" value="no" />
      </object>
    </div>
  );
}
